export enum ProcessingCommandsEnum {
  ContrastBrightnessIntensity = 'ContrastBrightnessIntensity',
  GammaCorrect = 'GammaCorrect',
  Sharpen = 'Sharpen'
}
